class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.setupListeners();
    if(this.classList.contains('js-no-history')) {
      this.changeHistory = false;
    }else{
      this.changeHistory = true;
    }

  }

  updateProductSliderImageOnLoad(){
    
    let variantWrap = document.querySelector('#productSingle variant-selects');
    let isKidsBeautyProduct = document.querySelector('.pdp-kids-beauty');
    let isConsolidatedPDP = document.querySelector('#consolidated-pdp');
    if(isKidsBeautyProduct || isConsolidatedPDP) {
      return;
    }
    if(variantWrap){
      let variantData = document.querySelector('#productSingle variant-selects [type="application/json"]');
      if(variantData){
        let variantDataParsed = JSON.parse(variantData.textContent);
        let variantSelect = document.querySelectorAll('#productSingle variant-selects select')[0];
        let selectedVariant = variantSelect.options[variantSelect.selectedIndex].text;
        
        let productGalleryImages = document.querySelector('product-gallery-images');
        let pdpGalleryFirstImg = document.querySelector('#productSingleGallery .swiper-wrapper .main-gallery__catalogue-image img')
        let pdpGalleryThumbsFirstImg = document.querySelector('.product-single__thumbnails .thumbnail__catalogue-image img')
        
        if (productGalleryImages) {
          variantDataParsed.forEach(variant => {
            if (variant.title == selectedVariant) {
              let image = variant.featured_media;
              let imagePosition = image.position;
              let imageSrc = image.preview_image.src;
              
              if(pdpGalleryFirstImg && pdpGalleryThumbsFirstImg && productGalleryImages){
                pdpGalleryFirstImg.src = imageSrc;
                pdpGalleryFirstImg.srcset = imageSrc;
                pdpGalleryThumbsFirstImg.src = imageSrc;
              }else{
                // window.innerWidth < 989 ? imagePosition += 1 : '';
                // productGalleryImages.updateActiveImage(imagePosition);
              }
            }
          });
        }
      }
    }
  }

  updateProductSliderImage(){
    let currVariant = this.currentVariant;
    let id = this.dataset.productId;
    let productSingleWrap = document.getElementById('productSingle');
    if(productSingleWrap){
      if(productSingleWrap.dataset.productId == id){
        let productGalleryImages = document.querySelector('product-gallery-images');
        let pdpGalleryFirstImg = document.querySelectorAll('.product-single__top-container .product-single__main-image > img')
        let pdpGalleryThumbsFirstImg = document.querySelector('.product-single__thumbnails .thumbnail__catalogue-image img')
        let pdpGalleryFirstImgMobile = document.querySelector('#productSingleGallery .swiper-wrapper .main-gallery__catalogue-image img')

        if(productGalleryImages){
          if (currVariant) {
            let variantFeaturedImage = currVariant.featured_media;
            // let imagePosition = currVariant.featured_media.position;
            let variantFeaturedImageSrc = variantFeaturedImage.preview_image.src
            if(pdpGalleryFirstImg && pdpGalleryThumbsFirstImg){
              // pdpGalleryThumbsFirstImg.src = variantFeaturedImageSrc;

              pdpGalleryFirstImg.forEach(img => {
                img.src = variantFeaturedImageSrc;
                img.srcset = variantFeaturedImageSrc;
              });

              // window.innerWidth < 989 ? imagePosition += 1 : '';
              // productGalleryImages.updateActiveImage(imagePosition);
            }

            if(pdpGalleryFirstImgMobile) {
              pdpGalleryFirstImgMobile.src = variantFeaturedImageSrc;
              pdpGalleryFirstImgMobile.srcset = variantFeaturedImageSrc;
            }
          }
        }
      }
    }
  }

  setupListeners() {
    // let colorOpts = this.querySelectorAll('.optiontype__color');
    // let sizeOpts = this.querySelectorAll('.optiontype__size');
    // let self = this;
    // colorOpts.forEach(function(el){ 
    //   el.addEventListener('change', function(){ 
    //     //console.log(this.value);
    //     self.querySelector('.product-form__option-label[data-option-label=color]').innerText = this.value;
    //     });
    // });

    // sizeOpts.forEach(function(el){ 
    //   el.addEventListener('change', function(){ 
    //     //console.log(this.value);
    //     // self.querySelector('.product-form__option-label[data-option-label=size]').innerText = this.value;
    //   });
    // });

    this.updateProductSliderImageOnLoad();
  }

  onVariantChange() {
    const element = this;
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    this.updateCartCrossSell();
    this.dispatchVariantChangeEvent();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateVariantImagePLP();
      this.updateProductSliderImage();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo(element);
    }

    this.dispatchLoopEvent();

  }

  updateCartCrossSell(){
    let self = this;
    if(self.closest(".cart__cross-sell")){
      let currVariant = self.currentVariant;
      let currVariantId = currVariant.id;
      let currVariantPrice = currVariant.price;
      let currVariantPriceString = currVariantPrice.toString();
      let currVariantPriceWithoutPence = currVariantPriceString;
      currVariantPriceWithoutPence = currVariantPriceWithoutPence.substring(0, currVariantPriceWithoutPence.length - 2);
      let currVariantPricePence = currVariantPriceString.slice(-2);
      let finalPrice = '$' + currVariantPriceWithoutPence + '.' + currVariantPricePence;
      self.closest(".mini-product-grid-item__form").querySelector('[data-product-price]').innerText = finalPrice;
      self.closest(".mini-product-grid-item__form").querySelector('product-form input[name="id"]').value = currVariantId;
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantImagePLP() {
    if (!this.currentVariant) return;

    if(this.currentVariant?.featured_image) {
      const productContainer = this.closest('.product-grid-item');
      const productImageElement = productContainer ? productContainer.querySelector('.product-grid-item__image img') : undefined;
      const newImage = this.currentVariant?.featured_image.src;
      if(productImageElement && productImageElement.src !== newImage) {
        productImageElement.src = newImage;
        productImageElement.srcset = newImage;
      }
    }
  }

  updateMedia() {
    // if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    if (!this.currentVariant) return;
    //console.log(this.currentVariant.options);
    //get
   
    //if one option, dont run, as this will only work with colors
    if(this.currentVariant.options.length < 2) {
      return;
    }

    const varOpt1 = this.currentVariant.option1;
    const varOpt2 = this.currentVariant.option2;
    const varOpt3 = this.currentVariant.option2;

    let matchCount = 0;
    let hasNewMedia = false;
    if(this.currentVariant?.featured_media) {
      const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );
      if (newMedia) {
        let hasNewMedia = true;
        const parent = newMedia.parentElement;
        //console.log(this.currentVariant.featured_media);
        newMedia.setAttribute('data-alt', this.currentVariant.featured_media.alt);
        parent.prepend(newMedia);
      }
    }
    
    

    //get all product images
    let self = this;
    let productImageContainers = document.querySelectorAll('.js-product-image');
    productImageContainers.forEach(function(el){
      el.classList.add('hidden');
      let altVal = el.dataset.alt.toLowerCase();
      let isMatch = false;
      if(altVal == varOpt1.toLowerCase() && varOpt1 != "") {
        //match!
        isMatch = true;
      }else if(altVal == varOpt2.toLowerCase() && varOpt2 != "") {
        //match!
        isMatch = true;
      }else if(altVal == varOpt3.toLowerCase() && varOpt3 != "") {
        //match!
        isMatch = true;
      }

      if(isMatch == true) {
        el.classList.remove('hidden');
        matchCount += 1;
      }

      if(hasNewMedia) {newMedia.classList.remove('hidden');}
      

    });

    //if no match, show all
    if(matchCount < 1) {
      productImageContainers.forEach(function(el){
        el.classList.remove('hidden');
      });
    }

    window.setTimeout(() => { parent.scroll(0, 0) });


    document.querySelector('slider-component').construct();

  }

  updateURL() {
    if (!this.currentVariant) return;
    if(this.changeHistory) {
      window.history.replaceState({ }, '', `?variant=${this.currentVariant.id}`);
    }
  }

  updateVariantInput() {
    let productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    // console.log("variant: " , this.dataset.section);
    if(
        this.dataset.section == "collection" || 
        this.dataset.section == "collection-subscription" || 
        this.dataset.section == "template-subscriptions-collection-one" ||
        this.dataset.section == "template-subscriptions-collection-two" ||
        this.dataset.section == "template-subscriptions-collection-three" || 
        this.dataset.section == "search" || 
        this.dataset.section == "cart-recommendations"
      ) {
      productForms = document.querySelectorAll(`#product-form-${this.dataset.uniqueid}`);
    }
    
    productForms.forEach((productForm) => {
      let currFormSelector = `#ProductForm-${this.dataset.productId}`;
      let currForm = productForm.querySelector(currFormSelector);
      if(currForm) {
        let input = currForm.querySelector('input[name="id"]');
        console.log(input);
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo(element) {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        //render price
        const id = `price-${this.dataset.productId}`;
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const comparePriceElement = html.querySelector('#productSingle .product-single__price [data-compare-price]');
        const savingsBadge = destination.querySelector('[data-savings-badge-percentage]');
        if(destination && destination.querySelector('[data-subscription-discount]')) {
          // let subscriptionDiscountPercentage = destination.querySelector('[data-subscription-discount]').getAttribute('data-subscription-discount');
          let variantPrice = source.querySelector('[data-product-price]').getAttribute('data-product-price');
          // let discountedVariantPrice = variantPrice * subscriptionDiscountPercentage;

          destination.querySelector('[data-product-price]').innerText = variantPrice;
          if(comparePriceElement) {
            destination.querySelector('[data-compare-price]').innerText = comparePriceElement.innerText;
            if(savingsBadge) {
              const comparePrice = parseFloat(comparePriceElement.innerText.replace('$', ''));
              const discount = comparePrice - parseFloat(variantPrice.replace('$', ''));
              const discountPercentage = Math.round(discount / comparePrice * 100);
              savingsBadge.innerText = discountPercentage + '%';
            }
          } else {
            // This is pulled in case there is no compare price set for the product
            const fullPriceWithoutSubscription = html.querySelector('[data-product-price]');
            destination.querySelector('[data-compare-price]').innerText = fullPriceWithoutSubscription.innerText;
            if(savingsBadge) {
              const fullPrice = parseFloat(fullPriceWithoutSubscription.innerText.replace('$', ''));
              const discount = fullPrice - parseFloat(variantPrice.replace('$', ''));
              const discountPercentage = Math.round(discount / fullPrice * 100);
              savingsBadge.innerText = discountPercentage + '%';
            }
          }
          
          this.closest('.product-grid-form').querySelector('[data-button-subscription-price]').innerText = variantPrice;
          // destination.innerHTML = source.innerHTML;
        } else{
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
        //Tontine App to correct change prices at above step
        if (window.TontineApp && window.TontineApp.app) {
          window.TontineApp?.app?.run();
        }

        //render availability
        const availid = `availability-${this.dataset.section}`;
        const availDestination = document.getElementById(availid);
        const availSource = html.getElementById(availid);
        if (availDestination && availSource) availDestination.innerHTML = availSource.innerHTML;

        // Update free shipping in benefits
        let productBenefits = document.querySelector(`.product-benefits--${this.dataset.section}.product-single__supporting-text.benefitsbar`);
        let productBenefitsSource = html.querySelector(`.product-benefits--${this.dataset.section}.product-single__supporting-text.benefitsbar`);

        if (productBenefits && productBenefitsSource) productBenefits.innerHTML = productBenefitsSource.innerHTML;

        if(productBenefits && productBenefitsSource){
          productBenefits.innerHTML = productBenefitsSource.innerHTML;
        }

        const currPrice = '.loop-one-time-purchase-option-price-amount';

        // Set plan selector prices
        if(html.querySelector('.loop-selling-plan-fieldset') !== null){
          // let subscriptionPrice = html.querySelector('.loop-subscription-group .loop-subscription-group-price-container').innerHTML;
          // let basePrice = html.querySelector(currPrice).innerText;
          // document.querySelector('.loop-subscription-group-price-container') ? document.querySelector('.loop-subscription-group-price-container').innerHTML = subscriptionPrice : '';
          // document.querySelector('[data-plan-selector-one-time-price]') ? document.querySelector('[data-plan-selector-one-time-price]').innerHTML = basePrice : '';
          // document.querySelector('.loop-one-time-purchase-option-price-amount') ? document.querySelector('.loop-one-time-purchase-option-price-amount').innerHTML = basePrice : '';
          // document.querySelector('.plan-selector__options--subscribe') ? document.querySelector('.plan-selector__options--subscribe').setAttribute('data-prod-price', subscriptionPrice) : '';
          // document.querySelector('.plan-selector__options--onetime') ? document.querySelector('.plan-selector__options--onetime').setAttribute('data-prod-price', basePrice) : '';
        }



        //set points price
        let currentPrice = 0;
        let pointCTAs = document.querySelectorAll('[data-product-points]');
        let purchaseOptionSelectors = document.querySelectorAll('[data-purchase-option-selector]');
        let priceSaving = document.querySelector('.product-single__price--saving');

        if(html.querySelector(currPrice)){
          if(purchaseOptionSelectors.length > 0){
            purchaseOptionSelectors.forEach(selector => {
              if(selector.checked){
                currentPrice = selector.closest('.plan-selector__options').dataset.prodPrice.replace("$","");
                if(selector.checked){
                  if(selector.id == 'subsave'){
                    priceSaving ? priceSaving.style.display = 'none' : '';
                  } else{
                    priceSaving ? priceSaving.style.display = 'block' : '';
                  }
                }
              }
            });
          } else {
            currentPrice = parseInt(html.querySelector(currPrice).innerText.replace(/\s/g, "").replace("$",""), false)
          }
        }

        pointCTAs.forEach(function(el){

          let multiply = el.getAttribute('data-multiplier');
          if(multiply) {
            el.innerText = Math.ceil(currentPrice * multiply);
          }else{
            el.innerText = Math.ceil(currentPrice);
          }
        });

        // console.log(this.currentVariant);
        document.getElementById(`price-${this.dataset.productId}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        // Update grid item form
        let prodId = this.dataset.productId;
        let currProductFormSelector = '[data-product-form-id=product-form-' + prodId + ']';
        let productForms = document.querySelectorAll(currProductFormSelector);
        let currVariant = this.currentVariant;

        productForms.forEach(function(productForm) {          
          if(productForm){
            if(currVariant.available == false){
              if(productForm.querySelector('.product-grid-form__add-to-cart')){
                productForm.querySelector('.product-grid-form__add-to-cart').disabled = true;
                productForm.querySelector('.product-grid-form__add-to-cart > span').innerText = window.variantStrings.soldOut;
              }
            }else {
              if(productForm.querySelector('.product-grid-form__add-to-cart')){
                productForm.querySelector('.product-grid-form__add-to-cart').disabled = false;
                productForm.querySelector('.product-grid-form__add-to-cart > span').innerText = window.variantStrings.addToCart;
              } 
            }
          }
        })

        // Update Fragrance Variants 
        let fragranceTemplate = document.getElementById('fragrance-product');
        let consolidatedTemplate = document.getElementById('consolidated-pdp');

        if(fragranceTemplate || consolidatedTemplate) {
          let fragranceBanner = document.querySelector('.section-container-fragrance-banner');
          let fragranceBannerSource = html.querySelector('.section-container-fragrance-banner');

          if(fragranceBanner && fragranceBannerSource){
            fragranceBanner.innerHTML = fragranceBannerSource.innerHTML;
          }

          let fragranceReviews = document.querySelector('.section-container-fragrance-reviews');
          let fragranceReviewsSource = html.querySelector('.section-container-fragrance-reviews');

          if(fragranceReviews && fragranceReviewsSource){
            fragranceReviews.innerHTML = fragranceReviewsSource.innerHTML;
            let fragranceReviewsCarousel = fragranceReviews.querySelector('.fragrance-reviews__content-container');
            
            if(fragranceReviewsCarousel) {
              initScrollCarousel(fragranceReviewsCarousel);
            }
          }

          let fragranceNotes = document.querySelector('.section-container-fragrance-notes');
          let fragranceNotesSource = html.querySelector('.section-container-fragrance-notes');

          if(fragranceNotes && fragranceNotesSource){
            fragranceNotes.innerHTML = fragranceNotesSource.innerHTML;
          }

          let fragranceFeatures = document.querySelector('.section-container-fragrance-features');
          let fragranceFeaturesSource = html.querySelector('.section-container-fragrance-features');

          if(fragranceFeatures && fragranceFeaturesSource){
            fragranceFeatures.innerHTML = fragranceFeaturesSource.innerHTML;
          }

          let fragranceGallery = document.querySelector('.product-single__gallery-container');
          let fragranceGallerySource = html.querySelector('.product-single__gallery-container');

          if(fragranceGallery && fragranceGallerySource){
            fragranceGallery.innerHTML = fragranceGallerySource.innerHTML;

          }
        }

        // Update Gallery Modal
        let pdpGalleryModal = document.querySelector('#product-gallery-modal-container');
        let pdpGalleryModalSource = html.querySelector('#product-gallery-modal-container');

        if(pdpGalleryModal && pdpGalleryModalSource){
          pdpGalleryModal.innerHTML = pdpGalleryModalSource.innerHTML;
        }

        // Update Stickers
        let isPDP = document.querySelector('.product-single__main-image');
        let isPLP = document.querySelector('#ProductGridContainer');

        if(isPDP) {
          let stickers = document.querySelector('.product-single__main-image .product-stickers-container');
          let stickersSource = html.querySelector('.product-single__main-image .product-stickers-container');
          if(stickers && stickersSource){
            stickers.innerHTML = stickersSource.innerHTML;
          }
        } 
        else if(isPLP) {
          let productId = element.closest('.product-grid-item').getAttribute('data-product-id');
          let stickers = document.querySelector(`[data-product-id="${productId}"]`).querySelector('.product-stickers-container');
          let stickersSource = html.querySelector('.product-single__main-image .product-stickers-container');
          if(stickers && stickersSource){
            stickers.innerHTML = stickersSource.innerHTML;
          }
        }

        // Update Variants for consolidated-pdp template
        
        // if(consolidatedTemplate) {
        //   let gallery = document.querySelector('.product-single__gallery-container');
        //   let gallerySource = html.querySelector('.product-single__gallery-container');

        //   debugger

        //   if(gallery && gallerySource){
        //     gallery.innerHTML = gallerySource.innerHTML;
        //   }
        // }
      });

  }

  updateSwsSectionButton(){
    
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const mainProductAddButton = document.querySelector(`#product-form-${this.dataset.section}.main-product__form [name="add"]`);
    let formButtons = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('.product-form__buttons');
    const stickyFormButtons = document.querySelector('.product-sticky-form__form  .product-form__buttons');
    const stickyFormAddButton = document.querySelector('.product-sticky-form__form')?.querySelector('[name="add"]');
    let klaviyoBisTrigger = document.querySelector('#productSingle .main-product__form .klaviyo-bis-trigger');
    const stickyFormKlaviyoBisTrigger = document.querySelector('.product-sticky-form__form .klaviyo-bis-trigger');

    // if(this.dataset.context === "mobile-plp") {
    //   addButton = this.closest('.product-grid-form').querySelector('[name="add"]');
    //   formButtons = this.closest('.product-grid-form').querySelector('.product-form__buttons');
    //   klaviyoBisTrigger = this.closest('.product-grid-form').querySelector('#productSingle .main-product__form .klaviyo-bis-trigger');
    //   debugger
    // }

    // Check if it is the SWS section
    if (this.closest('.pdp-sws-section')) {
      let swsSection = this.closest('.pdp-sws-section');
      let swsAddButton = swsSection.querySelector('[name="add"]');
      let currVariant = this.currentVariant;

      if (disable) {
        swsAddButton.setAttribute('disabled', true);
        if(!this.currentVariant.available) {
          swsAddButton.textContent = window.variantStrings.soldOut;
        }
      } else {
        swsAddButton.removeAttribute('disabled');
        swsAddButton.textContent = window.variantStrings.addToCart;
      }
      return
    } else{

      let currVariant = this.currentVariant;
      if(currVariant.available){
        formButtons ? formButtons.classList.remove('sold-out') : '' ;
        stickyFormButtons ? stickyFormButtons.classList.remove('sold-out') : '' ;
        
        addButton ? addButton.style.display = 'inline-block' : '' ;
        stickyFormAddButton ? stickyFormAddButton.style.display = 'inline-block' : '' ;
        klaviyoBisTrigger ? klaviyoBisTrigger.classList.remove('klaviyo-bis--active') : '' ;
        stickyFormKlaviyoBisTrigger ? stickyFormKlaviyoBisTrigger.classList.remove('klaviyo-bis--active') : '' ;
      }else{
        formButtons ? formButtons.classList.add('sold-out') : '' ;
        stickyFormButtons ? stickyFormButtons.classList.add('sold-out') : '' ;
        
        addButton ? addButton.style.display = 'none' : '' ;
        stickyFormAddButton ? stickyFormAddButton.style.display = 'none' : '' ;
        klaviyoBisTrigger ? klaviyoBisTrigger.classList.add('klaviyo-bis--active') : '' ;
        stickyFormKlaviyoBisTrigger ? stickyFormKlaviyoBisTrigger.classList.add('klaviyo-bis--active') : '' ;
      }

    }
    if (addButton){
      if(addButton.closest('.bundle-upsell__modal-product-info')){
        let soldOutText = addButton.querySelector('.sold-out');
        let availableText = addButton.querySelector('.available');
        let currVariant = this.currentVariant;
        if(this.currentVariant.available){
          addButton.removeAttribute('disabled');
          soldOutText.classList.add('hidden');
          availableText.classList.remove('hidden');
          addButton.style.display = 'flex';
        }else{
          addButton.setAttribute('disabled', true);
          addButton.style.display = 'flex';
          soldOutText.classList.remove('hidden');
          availableText.classList.add('hidden');
        }
      }
    }
    
    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.soldOut;
    document.getElementById(`price-${this.dataset.productId}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  }

  dispatchLoopEvent() {
    const variantEvent = new CustomEvent("loopVariantChange", {
      detail: {
        variantId : this.currentVariant.id
      },
    });
    document.dispatchEvent(variantEvent);
  }

  dispatchVariantChangeEvent() {
    const variantEvent = new CustomEvent("variantChange", {
      detail: {
        variantId : this.currentVariant.id
      },
    });
    document.dispatchEvent(variantEvent);
  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
